import { resolvePlayerName } from "../../../../sports/common/utils/player-utils";
import { getSafeOrDefault } from "../../../common/object-util";
import { DEFAULT_TEAM_UNIFORM } from "../../../../sports/common/players/TeamPlayer";

export const PlayerSerializer = {
    serialize(player, playerStat, team, gameContext) {
        const { uniform, active, positions, playerId } = player;
        const { abbrName, teamName } = team;
        const isStartOfSecondHalf = gameContext.isStartOfSecondHalf(
            gameContext.getCurrentPeriod()
        );
        const isEndOfGame = !!gameContext.finalizeSettings;
        const isInRedZone = gameContext.isInRedZone();
        const fullName = resolvePlayerName(player);

        const {
            defense,
            fieldGoal,
            fieldGoalBlocked,
            fieldGoalRedzone,
            kickoff,
            kickoffReturn,
            passing,
            penalty,
            puntReturn,
            punting,
            receiving,
            returned,
            rushing,
            stats
        } = playerStat;

        const assistedSackCount =
            stats.defense.sack.completed - stats.defense.sack.unassisted;
        const assistedTackleCount =
            stats.defense.tackle.completed - stats.defense.tackle.unassisted;
        const assistedTflCount =
            stats.defense.tackleForLoss.completed -
            stats.defense.tackleForLoss.unassisted;

        const hasStats = [
            "defense",
            "fieldGoal",
            "fieldGoalBlocked",
            "fieldGoalRedzone",
            "kickoff",
            "kickoffReturn",
            "misc",
            "passing",
            "penalty",
            "puntReturn",
            "punting",
            "receiving",
            "returned",
            "rushing"
        ].some(
            (key) => !!getSafeOrDefault(() => playerStat[key].hasStats, false)
        );

        return {
            MIN: 0, // TODO
            MIN_GOALIE: 0, // TODO
            SECONDS: 0, // TODO
            SEC_GOALIE: 0, // TODO
            completeName: fullName || `${abbrName || teamName}+${uniform}`, // Example was"Vis+10", Is this just "abbrName+uniform"?
            defPosition: "", // TODO
            defSortIndex: 0, // TODO
            defenseBlkdKick: fieldGoalBlocked?.completed, // This assumes that the kick referenced, is a field goal
            defenseFumbForc: defense.ff,
            defenseFumbRcvr: defense.fr,
            defensePassBrUp: stats.defense.passBrokenUp.completed,
            defenseQbh: 0, // TODO
            defenseSackA: assistedSackCount,
            defenseSackUa: stats.defense.sack.unassisted,
            defenseSackWinLossYards: stats.defense.sack.totalYards,
            defenseTotalSack:
                assistedSackCount / 2 + stats.defense.sack.unassisted,
            defenseSaf: stats.defense.safety.completed,
            defenseTackA: assistedTackleCount,
            defenseTackUa: stats.defense.tackle.unassisted,
            defenseTackUaA: 0, // TODO
            defenseTflA: assistedTflCount,
            defenseTflLossYards: 0, // Temporarily keeping this set to zero, previously came from: stats.defense.tackleForLoss.lostYards
            defenseTflUa: stats.defense.tackleForLoss.unassisted,

            /* Are these ep properties, used for PAT's? */
            epDefIfAt: 0, // TODO
            epDefKickRetAt: 0, // TODO
            epDefKickRetMd: 0, // TODO
            epDefRetMad: 0, // TODO
            epDefRetMadSco: 0, // TODO
            epOffKickAt: fieldGoal.patAttempted, // PAT Kicks Attempts
            epOffKickMd: fieldGoal.patCompleted, // PAT Kicks Made
            epOffPassAt: 0, // TODO
            epOffPassMd: 0, // TODO
            epOffRcvMd: 0, // TODO
            epOffRushAt: 0, // TODO
            epOffRushMd: 0, // TODO
            /********************************************/

            /* Where would these come from? Do we need to calculate them? */
            firstDownNo: 0, // TODO
            firstDownPass: 0, // TODO
            firstDownPenalty: 0, // TODO
            firstDownRush: 0, // TODO
            /**************************************************************/

            dropKickFieldGoal: fieldGoal.dropKickCompleted,
            dropKickFieldGoalAtt: fieldGoal.dropKickAttempted,
            dropKickPAT: fieldGoal.patDropKickCompleted,
            dropKickPATAtt: fieldGoal.patDropKickAttempted,
            fumblesLost: stats.offense.fumble.lost.completed,
            fumblesNo: stats.offense.fumble.total.completed,
            goalie: false, // TODO
            goalieStarter: false, // TODO
            inactive: !active,
            kickFgAtt: fieldGoal.attempted,
            kickFgBlk: fieldGoalBlocked.completed,
            kickFgLong: fieldGoal.longestYard,
            kickFgMad: fieldGoal.completed,
            kickKoNo: kickoff.completed,
            kickKoOb: 0, // TODO - I think this is kickoff out of bounds? Where is this found?
            kickKoTb: kickoff.touchback,
            kickKoDeuce: stats.kicks.deuce.completed,
            kickKoYards: kickoff.totalYards,
            kickPunt50: 0, // TODO - What is this? I see we collect a in20 value, but not 50
            kickPuntBlkd: stats.specialTeams.punt.blocked.completed,
            kickPuntFc: 0, // TODO - I think this is Punt Fair Catch, where would we find this?
            kickPuntI20: stats.specialTeams.punt.in20,
            kickPuntLong: stats.specialTeams.punt.longestYard,
            kickPuntNo: stats.specialTeams.punt.completed,
            kickPuntTb: stats.specialTeams.punt.touchback,
            kickPuntYards: stats.specialTeams.punt.totalYards,
            miscYards: 0, // TODO
            offPosition: "", // TODO
            offSortIndex: 0, // TODO
            onField: false, // TODO
            participated: hasStats || player.uniform === DEFAULT_TEAM_UNIFORM,
            passAtt: stats.offense.pass.attempted,
            passComp: stats.offense.pass.completed,
            passInt: stats.offense.pass.interceptions,
            passLong: stats.offense.pass.longestYard,
            passSackYards: Math.abs(stats.offense.sack.totalYards),
            passSacks: stats.offense.sack.completed,
            passTd: passing.touchdowns,
            passWinLoss: 0, // TODO
            passYards: passing.totalYards,
            penaltyNo: penalty.completed,
            penaltyYards: penalty.absoluteYards,
            playerId: playerId,
            pos: "", // TODO
            position: positions
                ?.filter((p) => p)
                .map((p) => p.code)
                .join("/"), // No example provided but I have this being set like: "WR/QB"
            readOrder: -1, // TODO
            receivingLong: receiving.longestYard,
            receivingNo: receiving.completed,
            receivingTd: receiving.touchdowns,
            receivingYards: receiving.totalYards,

            // If game ended with the team at the red zone.
            redZoneEndOfGame: isInRedZone && isEndOfGame,
            // If game went to half time with the team at the red zone.
            redZoneEndOfHalf: isInRedZone && isStartOfSecondHalf,
            redZoneEndOnDowns: 0, // TODO
            redZoneEndOnFga: 0, // TODO
            redZoneEndOnFumble: 0, // TODO
            redZoneEndOnIntCpt: 0, // TODO
            redZoneFgsMade: stats.kicks.fieldGoalRedzone.completed,
            redZoneOnSideAttempt: 0, // TODO
            redZoneOnSideRecover: 0, // TODO
            redZonePassingTds: 0, // TODO
            redZonePointsScored: 0, // TODO
            redZoneRushingTds: 0, // TODO
            redZoneTimeInside20: 0, // TODO
            redZoneTimeScored: 0, // TODO
            /*****************************************************************/

            returnsFumbLong: stats.defense.fumble.returned.longestYard,
            returnsFumbNo: stats.defense.fumble.returned.completed,
            returnsFumbTd: stats.defense.fumble.returned.touchdowns,
            returnsFumbYards: stats.defense.fumble.returned.totalYards,
            returnsIntLong: stats.defense.interceptionReturns.longestYard,
            returnsIntNo: stats.defense.interceptionReturns.completed,
            returnsIntTd: stats.defense.interceptionReturns.touchdowns,
            returnsIntYards: stats.defense.interceptionReturns.totalYards,
            returnsKickLong: stats.kicks.kickoffReturn.longestYard,
            returnsKickNo: stats.kicks.kickoffReturn.completed,
            returnsKickTd: stats.kicks.kickoffReturn.touchdowns,
            returnsKickYards: stats.kicks.kickoffReturn.totalYards,
            returnsPuntLong: stats.specialTeams.puntReturn.longestYard,
            returnsPuntNo: stats.specialTeams.puntReturn.completed,
            returnsPuntTd: stats.specialTeams.puntReturn.touchdowns,
            returnsPuntYards: stats.specialTeams.puntReturn.totalYards,
            rushAtt: stats.offense.rush.attempted,
            rushLong: stats.offense.rush.longestYard,
            rushTd: stats.offense.rush.touchdowns,
            rushWinLoss: 0, // TODO
            rushYards: stats.offense.rush.totalYards,
            seconds: 0, // TODO
            starter: false, // TODO
            starterDef: false, // TODO
            starterOff: false, // TODO
            uniform: uniform
        };
    }
};
